import { render } from "./RecentObjectsListItem.vue?vue&type=template&id=98aae316"
import script from "./RecentObjectsListItem.vue?vue&type=script&lang=js"
export * from "./RecentObjectsListItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__